export enum ColumnAggregationType {
  SUM = "SUM",
  MEAN = "MEAN",
  COUNT = "COUNT",
}

export enum TemplateLoadingType {
  EVERYTHING = "EVERYTHING",
  FIXED_PERIOD = "FIXED_PERIOD",
  RANGE = "RANGE",
}

export enum ProductTemplateSortingStrategy {
  KEY_AND_META_KEY = "KEY_AND_META_KEY",
  CREATION_DATE = "CREATION_DATE",
  ADVANCED = "ADVANCED",
}

export enum ProductTemplateSortingStrategyOptionsOrder {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
}

export enum CellType {
  LONG = "LONG",
  DOUBLE = "DOUBLE",
  STRING = "STRING",
  DATETIME = "DATETIME",
  DATASET = "DATASET",
  TIME = "TIME",
  TIMESPAN = "TIMESPAN",
  FILE = "FILE",
  USER_SIGNATURE = "USER_SIGNATURE",
  FOREIGN_KEY = "FOREIGN_KEY",
  INSTANT = "INSTANT",
  MULTI_VALUE = "MULTI_VALUE",
  MULTI_FOREIGN_KEY = "MULTI_FOREIGN_KEY",
}

export enum FileType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  TEXT = "TEXT",
  OTHER = "OTHER",
}

export enum CellSubType {
  LONG = "LONG",
  DOUBLE = "DOUBLE",
  STRING = "STRING",
  TIME = "TIME",
  TIMESPAN = "TIMESPAN",
  DATASET = "DATASET",
}

export enum RequestMethod {
  GET = "GET",
  POST = "POST",
  PATCH = "PATCH",
  DELETE = "DELETE",
  PUT = "PUT",
}

export enum SignStatus {
  UNDEFINED = "UNDEFINED",
  ALREADY_SIGNED = "ALREADY_SIGNED",
  CONDITIONS_MET = "CONDITIONS_MET",
  CONDITIONS_NOT_MET = "CONDITIONS_NOT_MET",
}

export enum Operator {
  STARTS_WITH = "START_WITH",
  CONTAINS = "CONTAINS",
  EQ = "EQ",
  NE = "NE",
  GT = "GT",
  GTE = "GTE",
  LT = "LT",
  LTE = "LTE",
}

export enum BoundType {
  MDM_DEVICE_IDENTIFIER = "MDM_DEVICE_IDENTIFIER",
  MDM_DEVICE_ID = "MDM_DEVICE_ID",
  MDM_OBJECT_IDENTIFIER = "MDM_OBJECT_IDENTIFIER",
  MDM_OBJECT_ID = "MDM_OBJECT_ID",
}

export enum DweenColors {
  Heat = "#D95648",
  PET = "#E0C05B",
  BMS = "#2BBD66",
  Air = "#616BF2",
  Dry = "#E97451",
  Boiler = "#9ACD32",
  Cold = "#46BBC2",
  Waste = "#B358C9",
  Black = "#000000",
  White = "#FFFFFF",
  Blue600 = "#003E79",
  Blue500 = "#005EB5",
  Blue400 = "#007DF2",
  Blue300 = "#2997FF",
  Blue200 = "#5EB1FF",
  Blue100 = "#94CBFF",
  Grey700 = "#2E3A3C",
  Grey600 = "#5C7577",
  Grey500 = "#ABBCBE",
  Grey400 = "#CED8D9",
  Grey300 = "#DAE2E3",
  Grey200 = "#E7EBEC",
  Grey100 = "#F3F5F6",
}

export enum JSONEditorMode {
  DASHBOARD = "dashboard",
  INPUT_GROUPS = "input-groups",
  MAPPER = "mapper",
}

export enum MapperEditorMode {
  CREATE = "CREATE",
  EDIT = "EDIT",
}

export enum MapperOperationObject {
  MAPPER = "mapper",
  MAPPINGS = "mappings",
}